import { RootState } from 'redux/store'

const selectSelectedAdministrationMenuKey: (state: RootState) => string = (state) =>
  state.administration.menu.selectedKey

export default selectSelectedAdministrationMenuKey
